
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacHeaderWithMenue from '@/templates/BacHeaderWithMenue.vue'
import BacBlueButton from '@/components/BacBlueButton.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import BacLazyImage from '@/components/BacLazyImage.vue'
import { RallyRoundButton } from '@/lib/models/RallyRoundButton'
import BacButton from '@/components/BacButton.vue'
import { checkAllowedToAccessPermission } from '@/lib/utils/RallyRoundAccess'

@Component({
  components: {
    BacHeaderWithMenue,
    BacBlueButton,
    BaseButton,
    BacLazyImage,
    BacButton
  }
})
export default class Base extends Vue {
  registerStateUrl = localStorage.getItem('registerStateLink')

  buttons: RallyRoundButton[] = []
  buttonsLoaded = false

  get bestlistButton () {
    const bestlistButton = new RallyRoundButton()
    bestlistButton.name = 'Bestenliste'
    bestlistButton.link = `/points/${this.rallyRound.id}`
    bestlistButton.image = '20.png'
    return bestlistButton
  }

  get showBestlistButton () {
    return new Date(this.rallyRound.dateEnd).getTime() <= new Date().getTime()
  }

  async mounted () {
    await checkAllowedToAccessPermission(this.$route.params.rallyRoundId)

    this.loadRallyRoundButtons()
    this.$store.dispatch('loadLoggedInUser')
    // this.fixHeaderSize()

    document.body.scrollTo(0, 0)

    setTimeout(() => {
      document.body.scrollTo(0, 0)
    }, 50)
  }

  get isAdmin () {
    return this.$store.state.LoggedInUser.user?.isAdmin
  }

  get rallyRound () {
    return this.$store.state.PageURLRallyRound.rallyRound
  }

  get sortedButtons () {
    return this.buttons.sort((a, b) => {
      return a.sort - b.sort
    })
  }

  /* fixHeaderSize () {
    const header = document.getElementsByTagName('header')[0]
    if (!header) {
      return
    }

    (this.$el as HTMLElement).style.marginTop = header.getClientRects()[0].height + 'px'
  } */

  async loadRallyRoundButtons () {
    if (localStorage.getItem(`rally-round-${this.$route.params.rallyRoundId}-buttons`)) {
      this.buttons = JSON.parse(localStorage.getItem(`rally-round-${this.$route.params.rallyRoundId}-buttons`) as any)
    }
    this.buttons = await RallyRoundButton.getAll({ params: [this.$route.params.rallyRoundId, 'buttons'] })
    localStorage.setItem(
      `rally-round-${this.$route.params.rallyRoundId}-buttons`,
      JSON.stringify(this.buttons)
    )
    this.buttonsLoaded = true
  }
}
